import styled, {keyframes} from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 476px;
`;

export const Tile = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  background-color: #1a1a1a;
  box-shadow: ${(props) =>
    props.shadow
      ? "12px 0 54px -4px rgba(0, 0, 0, 0.6), -12px 0 54px -4px rgba(0, 0, 0, 0.6)"
      : ""};
  z-index: ${(props) => (props.shadow ? "1" : "auto")};

  .tile-label {
    margin-top: -2.5em;
    font: italic normal 20px "Roboto Condensed";
    font-weight: bold;
    color: #fff;
  }
`;

export const ValueWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: ${(props) => props.width};
  margin: ${props => props.margin};

  .value-title {
    color: #fff;
    font: italic normal 18px "Roboto Condensed";
    font-weight: bold;
    text-align: center;
    margin-top: -3.25em;
  }
`;

export const Progress = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background-color: #000000;
  height: 20px;
  width: 80%;
  border-radius: 10px;
`;

export const Bar = styled.div`
  height: 19px;
  background-color: ${(props) => props.color};
  border-radius: 10px;
  /* width: ${(props) => props.value}%; */

  animation: ${props => changeWidth(props.value)} 1.5s ease-in-out;
  animation-fill-mode: forwards;
  animation-delay: 0.4s;
`;

const changeWidth = width => keyframes`
  0%{
    width: 0px
  }
  100% {
    width: ${width}%
  }
`



// WEBPACK FOOTER //
// ./src/components/ScoreSummary/ScoreSummary.styles.ts